module.exports = __webpack_public_path__ + "static/media/website-chingu.ff5fec24.png";